module.exports = __webpack_public_path__ + "static/lines-background-77390f4ee4e2b4dc392553e81726dde5.png";